
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcements",
      function () {
        return require("private-next-pages/announcements/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/announcements"])
      });
    }
  